import Vue from 'vue'
import VueI18n from 'vue-i18n'
import {getLanguage} from "./utils/utils";

Vue.use(VueI18n);

let showKey = localStorage.getItem('show_key')
if(showKey){
    showKey = JSON.parse(localStorage.getItem('show_key'))
}else{
    showKey = true
}

const messages = {
    vi: showKey ? $.getJSON({'url': process.env.VUE_APP_LANG_URL + "vi-VN.json", 'async': false}).responseJSON : '',
    en: showKey ? $.getJSON({'url': process.env.VUE_APP_LANG_URL + "en-EN.json", 'async': false}).responseJSON : '',
};
const lang = getLanguage();
const i18n = new VueI18n({
    locale: lang,
    messages,
    fallbackLocale: lang,
});

export default i18n
